import apiService from '../../../shared/services/api';

/**
 * Auth Service
 * Handles authentication requests
 */
class AuthService {
  /**
   * Verify Telegram authentication
   */
  async verifyTelegramAuth(initData, user) {
    return apiService.post('/auth/verify', {
      initData,
      user
    });
  }

  /**
   * Verify token authentication
   */
  async verifyTokenAuth(token) {
    return apiService.post('/auth/verify', {
      token
    });
  }
}

export default new AuthService();
